// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3Enq0","visuallyhidden":"ONHZ8","hide-text":"_34_Lg","center":"_2fTfA","noprint":"_1JGHy","timestamp":"v815a _25KE7"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-timestamp/styles/default.scss
 ** module id = 1024
 ** module chunks = 2
 **/